import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {VirtualMetricOPEEnum} from "./VirtualMetricOPEEnum";
import {
  AggregateInfo,
  VMInput,
  VMResettableConfig,
  VMScheduledConfig,
  VMTypeEnum
} from "../../models/virtualmetric/VirtualMetric";


class O {
  id!: number;
}

/**
 * O Inner Class
 */
class I {

  id!: number;
  partitionId!: number;
  name!: string;
  enabled!: boolean;
  type!: VMTypeEnum;
  expression!: string;
  isBoolean!: boolean;
  dataUnit!: DataUnitDTO;
  decimalDigits!: number;
  scheduledConfig!: VMScheduledConfigDTO;
  resettableConfig!: VMResettableConfig;
}

export class VMScheduledConfigDTO {
  cronExpression!: string;
  inputMetrics: VMInputDTO[] = [];

  constructor(scheduledConfig: VMScheduledConfig) {
    this.cronExpression = scheduledConfig.cronExpression;
    this.inputMetrics = [];
    scheduledConfig.inputMetrics.forEach(
      metric => {
        this.inputMetrics.push(new VMInputDTO(metric));
      }
    )
  }

}

class VMInputDTO {
  deviceId?: number;
  metricInstanceId!: number;
  alias!: string;
  aggregateInfo!: AggregateInfo;

  constructor(vmInput: VMInput) {
    if (!!vmInput.fullMetricInstance) {
      this.metricInstanceId = vmInput.fullMetricInstance?.id;
      this.deviceId = vmInput.fullMetricInstance.deviceId;
    }
    this.alias = vmInput.alias;
    if (!!vmInput.aggregateInfo) {
      this.aggregateInfo = vmInput.aggregateInfo;
    }
  }

}


class DataUnitDTO {
  name!: string;
}

/**
 * GetTransportItemDetailCB class
 */
export class PutVirtualMetricCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(VirtualMetricOPEEnum.PutVirtualMetric);
    this.i = new I();
    this.o = new O();
  }

}
